import { ParagraphProps } from './types';
import * as S from './styles';

export const Paragraph = ({ children, ...props }: ParagraphProps) => <S.Paragraph {...props}>{children}</S.Paragraph>;
